import React from 'react';
import { IWizardItem } from '../WizardItem';
import styles from './WizardAppNewsButton.module.scss';
import { useWizardContext } from '../../../Services/WizardContext';

interface Props {
	item: IWizardItem;
}

const WizardAppNewsButton: React.FC<Props> = ({ item }) => {
	const { handleSetScreen } = useWizardContext();

	const handleClick = (slideIndex: number) => {
		handleSetScreen('news_presentation', {
			slideIndex,
		});
	};

	return (
		<div
			className={styles.wrapper}
			onClick={() => handleClick(item?.settings?.slide ?? 0)}
		>
			{item?.settings?.icon && (
				<div className={styles.iconWrapper}>
					<img src={item.settings.icon} alt='icon' />
				</div>
			)}
			<div className={styles.content}>
				{item?.title && <div className={styles.title}>{item.title}</div>}
				{item?.description && (
					<div className={styles.description}>{item.description}</div>
				)}
			</div>
			<div className={styles.arrowButton}>
				<img
					src='./../../dist/patientV3/icons/arrow-right-purple-small.svg'
					alt='arrow'
				/>
			</div>
		</div>
	);
};

export default WizardAppNewsButton;
